import {FaStar} from "react-icons/fa6";
import {Link} from "react-router";

import CapterraPng from "@/assets/images/capterra.png";
import G2LogoPng from "@/assets/images/g2-logo.png";
import G2Png from "@/assets/images/g2-momentum-leader.png";
import GetAppPng from "@/assets/images/getapp.png";
import SoftwareAdvicePng from "@/assets/images/software-advice.png";
import SourceForgeLeaderSvg from "@/assets/images/sourceforge-leader.svg";
import SourceForgeLogoSvg from "@/assets/images/sourceforge-logo.svg";
import UserSvg from "@/assets/images/user.svg";

import styles from "./MarketingReviews.module.scss";

export enum Brand {
  SourceForge = "SourceForge",
  G2 = "G2",
}

const brandLogos = {
  [Brand.SourceForge]: <img src={SourceForgeLogoSvg} />,
  [Brand.G2]: <img src={G2LogoPng} />,
};

interface Review {
  brand: Brand;
  name: string;
  role: string;
  review: string;
}

interface MarketingReviewsProps {
  items: Review[];
}

export const MarketingReviews = ({items}: MarketingReviewsProps) => {
  return (
    <div className={styles.container}>
      <div className={`${styles.reviewContainer} d-flex align-items-center justify-content-center flex-wrap`}>
        {items.map(({brand, name, role, review}, index) => (
          <div key={`review-${index}`} className={`${styles.review} d-flex flex-column justify-content-between`}>
            <div className={`${styles.reviewBrand} d-flex align-items-center`}>
              <div className={`${styles.rating} flex-grow-1`}>
                <span className="me-2 marketingTextCaption pulse-color-gray-900">5.0</span>
                <FaStar /> <FaStar /> <FaStar /> <FaStar /> <FaStar />
              </div>
              <div className={styles.reviewLogo}>{brandLogos[brand]}</div>
            </div>
            <div className="marketingTextS2">{review}</div>
            <div className="d-flex align-items-center">
              <img src={UserSvg} alt="User image" className="me-3" />
              <div>
                <div className="marketingTextBodyBold">{name}</div>
                <div className="text-success marketingTextBody">
                  <small>{role}</small>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
      <div className={`${styles.brandContainer} d-flex align-items-center justify-content-center flex-wrap`}>
        <Link to="https://www.capterra.com/p/149314/Uptime/reviews/" target="_blank" rel="noopener noreferrer">
          <img src={CapterraPng} alt="Capterra logo" className={styles.capterra} />
        </Link>
        <div className={styles.middleBrands}>
          <Link
            to="https://www.getapp.ca/software/1556/uptime-infrastructure-mo"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img src={GetAppPng} alt="GetApp logo" className={styles.getApp} />
          </Link>
          <Link to="https://sourceforge.net/software/product/Uptime/" target="_blank" rel="noopener noreferrer">
            <img src={SourceForgeLeaderSvg} alt="SourceForge logo" className={styles.sourceForge} />
          </Link>
          <Link to="https://www.g2.com/products/uptime-com/reviews" target="_blank" rel="noopener noreferrer">
            <img src={G2Png} alt="G2 logo" className={styles.g2} />
          </Link>
        </div>
        <Link
          to="https://www.softwareadvice.com/network-monitoring/uptime-profile/"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img src={SoftwareAdvicePng} alt="SoftwareAdvice logo" className={styles.softwareAdvice} />
        </Link>
      </div>
    </div>
  );
};
